<div class="border-card border-0 px-4 py-1 scroll-container" ref="view_entity_type">
  <div class="d-flex justify-content-between align-items-center mb-1 me-4">
    <NavigationBackButton/>
    <div class="d-flex align-items-center gap-3">
        <span class="project-badge text-xs p-0 d-inline-flex align-items-center">
            <i class='bx bxs-bookmark-alt fs-5 me-1 text-primary-blue'></i>
            Entity Type / <span class="fw-bold p-1"> {{entity_type_name}}</span>
        </span>
        <span class="project-badge text-xs p-0 d-inline-flex align-items-center">
            <i class='bi bi-file-earmark-text fs-5 me-1 text-primary-blue'></i>
            Form / <span class="fw-bold p-1"> {{form_name}}</span>
        </span>
    </div>
  </div>
  
  <!-- Header with Rule Info -->
  <div class="glassy-table shadow-sm mb-4 border-0">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="text-xs fw-bold mb-1">Condition Management</h5>
          <p class="text-xxs text-muted mb-0" v-if="selected_rule">
            Managing conditions for: <strong>{{ selected_rule.name }}</strong>
            <span class="ms-3">| Form: <strong>{{ current_form_name }}</strong></span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Condition Button (above the table) -->
  <div class="d-block text-end mb-3">
    <button
      class="btn btn-primary-dark btn-sm rounded-small ms-3 text-xxs shadow text-dark"
      @click="open_add_condition_modal"
    >
      <i class="fas fa-plus me-1"></i> Add Condition
    </button>
  </div>

  <!-- Conditions Table -->
  <div class="p-2">
    <div class="shadow-sm border table-border-color rounded-lg p-3 table-responsive text-xs">
      <!-- Loading State -->
      <div v-if="is_loading_conditions" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
        <p class="text-muted mt-2 text-xs">Loading conditions...</p>
      </div>

      <!-- Table when conditions exist -->
      <table
        v-else-if="table_safe_conditions.length > 0"
        id="condition_management_table"
        class="table table-hover"
      >
        <thead class="custom-header">
          <tr>
            <th>No</th>
            <th>Type</th>
            <th>Field/Item</th>
            <th>Operator</th>
            <th>Value</th>
            <th>Max Value</th>
            <th>Options</th>
            <th>Logical Operator</th>
            <th>Version</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(condition, index) in table_safe_conditions" :key="condition.id">
            <td>{{ index + 1 }}</td>
            <td>
              <span class="badge me-2" :class="get_condition_type_class(condition.condition_type)">
                {{ format_condition_type(condition.condition_type) }}
              </span>
            </td>
            <td>
              <span class="text-xs">
                {{ get_field_item_display(condition) || '-' }}
              </span>
            </td>
            <td>
              <span class="badge bg-info">
                {{ format_operator(condition.operator) }}
              </span>
            </td>
            <td>
              <span class="fw-medium">{{ condition.value || '-' }}</span>
            </td>
            <td>
              {{ condition.comparison_value || '-' }}
            </td>
            <td>
            <span class="text-xs">
              {{ format_selected_options(condition.selected_options) || '-' }}
            </span>
          </td>
            <td>
              <span class="badge" :class="get_logical_operator_class(condition.logical_operator)">
                {{ condition.logical_operator || 'AND' }}
              </span>
            </td>
            <td>
              <span class="badge bg-secondary">{{ condition.version || 1 }}</span>
            </td>
            <td>{{ format_date(condition.created_at) }}</td>
            <td class="text-nowrap">
              <div class="d-flex flex-wrap gap-1 justify-content-start">
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="open_edit_condition_modal(condition)"
                >
                  Edit
                </button>
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="open_assign_question_modal(condition)"
                  data-bs-toggle="modal" data-bs-target="#assign_questions_modal"
                >
                  Assign question
                </button>
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="confirm_delete_condition(condition)"
                >
                  Delete
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Empty State -->
      <div v-else class="text-center py-5">
        <h6 class="text-muted text-xs mb-2">No Conditions Found</h6>
        <p class="text-xxs text-muted">
          Click <strong>Add Condition</strong> to create your first condition for this rule.
        </p>
      </div>
    </div>
  </div>

  <!-- Condition Preview Card -->
  <div class="p-2 mt-3">
    <div class="card shadow-sm border table-border-color rounded-lg p-3 text-xs">
      <div class="d-flex align-items-center mb-3">
        <i class="fas fa-code me-2 text-primary-blue"></i>
        <h6 class="text-xs fw-bold mb-0">Condition Summary</h6>
      </div>
      <div v-if="table_safe_conditions.length > 0" class="bg-light p-3 rounded text-xs">
        {{ generate_condition_summary }}
      </div>
      <div v-else class="text-center py-3">
        <p class="text-muted text-xxs mb-0">No conditions to preview</p>
      </div>
    </div>
  </div>

  <!-- Add/Edit Condition Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="condition_modal"
      ref="conditionModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg border-0">
          <!-- Modal Header -->
          <div class="modal-header border-bottom-0 cute-header shadow-sm">
            <p class="modal-title text-white text-xxs" id="condition_modal_label">
              {{ condition_form.id ? 'Edit Condition' : 'Add New Condition' }}
            </p>
            <button
              type="button"
              class="modal-btn-close btn-close btn-close-white"
              @click="close_condition_modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body p-3">
            <!-- Condition Type -->
            <div class="modal-form-group form-group mb-3">
              <label for="condition_type" class="modal-form-label form-label text-xxs">Condition Type *</label>
              <select
                id="condition_type"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.condition_type"
                @change="on_condition_type_change"
                :class="{ 'is-invalid': errors.condition_type }"
              >
                <option value="" disabled hidden>Select condition type</option>
                <option
                  v-for="type in condition_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.label }}
                </option>
              </select>
              <div v-if="errors.condition_type" class="invalid-feedback text-xxs">
                {{ errors.condition_type }}
              </div>
            </div>

            <!-- Compliance Field (for question_response type) -->
            <div class="modal-form-group form-group mb-3" v-if="should_show_compliance_field">
              <label for="compliance_field" class="modal-form-label form-label text-xxs">Compliance Field</label>
              <select
                id="compliance_field"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.compliance_field"
                :class="{ 'is-invalid': errors.compliance_field }"
              >
                <option value="">Select compliance field (optional)</option>
                <option
                  v-for="field in compliance_fields"
                  :key="field.id"
                  :value="field.id"
                >
                  {{ field.name || field.field_name || `Field ${field.id}` }}
                </option>
              </select>
              <small class="text-muted text-xxs">
                Select the field to check for question response conditions
              </small>
            </div>

            <!-- Result Action Question (for question_response type) -->
            <div class="modal-form-group form-group mb-3" v-if="should_show_result_action_question">
              <label for="result_action_question" class="modal-form-label form-label text-xxs">Result Action Question</label>
              <select
                id="result_action_question"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.result_action_question"
              >
                <option value="">Select result action question (optional)</option>
                <option
                  v-for="question in result_action_questions"
                  :key="question.id"
                  :value="question.id"
                >
                  {{ question.question_text || question.name || `Question ${question.id}` }}
                </option>
              </select>
              <small class="text-muted text-xxs">
                Alternative to compliance field
              </small>
            </div>

            <!-- Checklist Item (for checklist_item type) -->
            <div class="modal-form-group form-group mb-3" v-if="should_show_checklist_item">
              <label for="checklist_item_association" class="modal-form-label form-label text-xxs">Checklist Item *</label>
              <select
                id="checklist_item_association"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.checklist_item_association"
                :class="{ 'is-invalid': errors.checklist_item_association }"
              >
                <option value="" disabled hidden>Select checklist item</option>
                <option
                  v-for="item in checklist_items"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.item_name || item.description || `Item ${item.id}` }}
                </option>
              </select>
              <div v-if="errors.checklist_item_association" class="invalid-feedback text-xxs">
                {{ errors.checklist_item_association }}
              </div>
            </div>

            <!-- Operator -->
            <div class="modal-form-group form-group mb-3">
              <label for="operator" class="modal-form-label form-label text-xxs">Operator *</label>
              <select
                id="operator"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.operator"
                @change="on_operator_change"
                :disabled="!condition_form.condition_type"
                :class="{ 'is-invalid': errors.operator }"
              >
                <option value="" disabled hidden>Select operator</option>
                <option
                  v-for="op in filtered_operators"
                  :key="op.value"
                  :value="op.value"
                >
                  {{ op.label }}
                </option>
              </select>
              <div v-if="errors.operator" class="invalid-feedback text-xxs">
                {{ errors.operator }}
              </div>
            </div>

            <!-- Value (for single value operators) -->
            <div class="modal-form-group form-group mb-3" v-if="!should_show_multi_select && !should_show_value_max">
              <label for="value" class="modal-form-label form-label text-xxs">Value *</label>
              <input
                type="text"
                id="value"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.value"
                :placeholder="get_value_placeholder()"
                :disabled="!condition_form.operator"
                :class="{ 'is-invalid': errors.value }"
              />
              <div v-if="errors.value" class="invalid-feedback text-xxs">
                {{ errors.value }}
              </div>
              <small class="text-muted text-xxs">
                {{ get_value_hint() }}
              </small>
            </div>

            <!-- Value and Max Value (for between operator) -->
            <div class="row" v-if="should_show_value_max">
              <div class="col-6">
                <div class="modal-form-group form-group mb-3">
                  <label for="value" class="modal-form-label form-label text-xxs">Start Value *</label>
                  <input
                    type="text"
                    id="value"
                    class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                    v-model="condition_form.value"
                    :placeholder="get_value_placeholder()"
                    :class="{ 'is-invalid': errors.value }"
                  />
                  <div v-if="errors.value" class="invalid-feedback text-xxs">
                    {{ errors.value }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="modal-form-group form-group mb-3">
                  <label for="comparison_value" class="modal-form-label form-label text-xxs">End Value *</label>
                  <input
                    type="text"
                    id="comparison_value"
                    class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                    v-model="condition_form.comparison_value"
                    :placeholder="get_value_max_placeholder()"
                    :class="{ 'is-invalid': errors.comparison_value }"
                  />
                  <div v-if="errors.comparison_value" class="invalid-feedback text-xxs">
                    {{ errors.comparison_value }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Multi-select for "in" and "not_in" operators -->
            <div class="modal-form-group form-group mb-3" v-if="should_show_multi_select">
              <label for="selected_options" class="modal-form-label form-label text-xxs">Options *</label>
              <div class="input-group">
                <input
                  type="text"
                  id="selected_options"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                  :value="format_options_array(condition_form.selected_options)"
                  @input="condition_form.selected_options = parse_options_string($event.target.value)"
                  placeholder="Enter comma-separated values (value1, value2, value3)"
                  :class="{ 'is-invalid': errors.selected_options }"
                />
                <button
                  class="btn btn-outline-secondary btn-sm"
                  type="button"
                  @click="condition_form.selected_options = []"
                  title="Clear options"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <div v-if="errors.selected_options" class="invalid-feedback text-xxs">
                {{ errors.selected_options }}
              </div>
              <small class="text-muted text-xxs">
                Enter multiple values separated by commas. Example: "option1, option2, option3"
              </small>
            </div>

            <!-- Version -->
            <div class="modal-form-group form-group mb-3">
              <label for="version" class="modal-form-label form-label text-xxs">Version *</label>
              <input
                type="number"
                id="version"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                v-model.number="condition_form.version"
                min="1"
                :class="{ 'is-invalid': errors.version }"
              />
              <div v-if="errors.version" class="invalid-feedback text-xxs">
                {{ errors.version }}
              </div>
              <small class="text-muted text-xxs">
                Condition version (increment when making significant changes)
              </small>
            </div>

            <!-- Logical Operator -->
            <div class="modal-form-group form-group mb-3">
              <label for="logical_operator" class="modal-form-label form-label text-xxs">Logical Operator</label>
              <select
                id="logical_operator"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                v-model="condition_form.logical_operator"
              >
                <option
                  v-for="op in logical_operators"
                  :key="op.value"
                  :value="op.value"
                >
                  {{ op.label }}
                </option>
              </select>
              <small class="text-muted text-xxs">
                How this condition combines with others
              </small>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer border-top p-3">
            <button
              type="button"
              class="btn btn-secondary btn-sm rounded-small text-xxs shadow text-dark me-2"
              @click="close_condition_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="save_condition"
              :disabled="is_saving_condition"
            >
              {{ is_saving_condition ? 'Saving...' : (condition_form.id ? 'Update Condition' : 'Save Condition') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>


  <!-- Delete Confirmation Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="delete_condition_modal"
      ref="deleteConditionModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-sm">
            <p class="modal-title text-white text-xxs">Confirm Delete</p>
            <button
              type="button"
              class="modal-btn-close btn-close btn-close-white"
              @click="close_delete_modal"
            ></button>
          </div>
          <div class="modal-body p-3">
            <div class="text-center mb-3">
              <i class="fas fa-exclamation-triangle text-warning fa-2x mb-2"></i>
            </div>
            <p class="text-xs text-center mb-2">
              Are you sure you want to delete this condition?
            </p>
            <div v-if="condition_to_delete" class="alert alert-warning text-xs mb-0">
              <div class="row">
                <div class="col-6">
                  <strong>Type:</strong><br>
                  {{ format_condition_type(condition_to_delete.condition_type) }}
                </div>
                <div class="col-6">
                  <strong>Operator:</strong><br>
                  {{ format_operator(condition_to_delete.operator) }}
                </div>
                <div class="col-12 mt-2">
                  <strong>Value:</strong><br>
                  {{ condition_to_delete.value }}
                  <span v-if="condition_to_delete.comparison_value">
                    to {{ condition_to_delete.comparison_value }}
                  </span>
                </div>
                <div class="col-12 mt-2" v-if="condition_to_delete.selected_options">
                  <strong>Options:</strong><br>
                  {{ format_selected_options(condition_to_delete.selected_options) }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top p-3">
            <button
              type="button"
              class="btn btn-secondary btn-sm rounded-small text-xxs shadow text-dark me-2"
              @click="close_delete_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm rounded-small text-xxs shadow text-dark"
              @click="delete_condition"
              :disabled="is_deleting"
            >
              {{ is_deleting ? 'Deleting...' : 'Delete Condition' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

<!-- Question Assignment Modal Component -->
  <ConditionQuestionAssignment
    :selected_rule="selected_rule"
    :selected_condition="condition_for_assignment" 
    :is_visible="show_assign_modal"
    @close="close_assign_questions_modal"
    @updated="on_assignment_updated"
  />
</div>